import { UserProfileNode } from 'app/core/enums';
import { StepBarNode } from '../step-bar';

export const USER_PROFILE_NODE_CONFIGS: StepBarNode[] = [
  {
    key: UserProfileNode.PracticeInfo,
    title: 'general.practiceInfo',
  },
  {
    key: UserProfileNode.CreditCard,
    title: 'general.creditCard',
  },
];
